import Moment from 'moment';
import {
	SET_COST_UNIT_STATUS_STATISTICS_DATA,
	SET_APP_USER_STATISTICS,
	SET_USER_STATISTICS,
	SET_REPORT_TYPE_STATISTICS,
	SIGNOUT_USER,
	SET_ADMIN_REPORT_STATISTICS,
	SET_ADMIN_REPORT_STATISTICS_TYPE_FILTER,
	SET_ADMIN_REPORT_STATISTICS_DATE,
	SERVER_GET_ADMIN_REPORT_STATISTICS,
	SERVER_GET_ORGANISATION_STATISTICS,
	SET_ORGANISATION_STATISTICS,
	GET_ORGANISATION_STATISTICS_ERROR
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	costUnitStatus: [],
	appUserStatistics: {
		userCounter: {
			android: 0,
			ios: 0
		},
		userTypeReportCounter: {
			android: 0,
			ios: 0,
			web: 0
		},
		reportTypeStatistics: []
	},
	adminReportStatistics: {
		newReportsMonth: 0,
		newReportsWeek: 0,
		completedReportsMonth: 0,
		completedReportsWeek: 0,
		charts: []
	},
	userStatistics: {
		newReportsMonth: 0,
		newReportsWeek: 0,
		completedReportsMonth: 0,
		completedReportsWeek: 0,
		charts: []
	},
	typeFilter: [],
	organisationStatistics: {
		countTotal: 0,
		countNew: 0,
		averageNew: 0,
		countSeen: 0,
		countInProgress: 0,
		countCompleted: 0,
		averageCompleted: 0,
		countDeleted: 0,
		averageDeleted: 0,
		countTypes: [],
		countTime: [],
		countDay: [],
		countMonth: [],
		countMonthTypes: [],
		timeToFinishByType: [],
		yearHistory: [],
		countSupTypes: [],
		countMonthSupTypes: [],
		timeToFinishBySupType: [],
		countReportsByRelevanceAndFeedback: [],
		feedbackData: []
	},
	adminReportStatisticsDate: Moment().toDate(),
	loading: {
		adminReportStatistics: false,
		organisationStatistics: false
	},
	errors: {
		organisationStatistics: false,
		organisationStatisticsPermission: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_COST_UNIT_STATUS_STATISTICS_DATA:
			return { ...state, costUnitStatus: action.payload };
		case SET_APP_USER_STATISTICS:
			return { ...state, appUserStatistics: action.payload };
		case SET_REPORT_TYPE_STATISTICS:
			return { ...state, reportTypeStatistics: action.payload };
		case SET_USER_STATISTICS:
			return { ...state, userStatistics: action.payload.statistics };
		case SET_ADMIN_REPORT_STATISTICS:
			return {
				...state,
				adminReportStatistics: action.payload.statistics,
				loading: {
					...state.loading,
					adminReportStatistics: false
				}
			};
		case SET_ADMIN_REPORT_STATISTICS_TYPE_FILTER:
			return { ...state, typeFilter: action.payload.filter };
		case SET_ADMIN_REPORT_STATISTICS_DATE:
			return { ...state, adminReportStatisticsDate: action.payload.date };
		case SERVER_GET_ADMIN_REPORT_STATISTICS:
			return {
				...state,
				loading: { ...state.loading, adminReportStatistics: true }
			};
		case SERVER_GET_ORGANISATION_STATISTICS:
			return {
				...state,
				loading: { ...state.loading, organisationStatistics: true },
				errors: { ...state.errors, organisationStatistics: false, organisationStatisticsPermission: false }
			};
		case SET_ORGANISATION_STATISTICS:
			return {
				...state,
				organisationStatistics: action.payload,
				loading: { ...state.loading, organisationStatistics: false },
				errors: { ...state.errors, organisationStatistics: false, organisationStatisticsPermission: false }
			};
		case GET_ORGANISATION_STATISTICS_ERROR:
			return {
				...state,
				loading: { ...state.loading, organisationStatistics: false },
				errors: { ...state.errors, organisationStatistics: true, organisationStatisticsPermission: action.payload.permissionError }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Statistics.js